import React, { Component } from 'react';
import { connect } from 'react-redux';
import FotaCarsActions from '../../redux/CarFirmwaresRedux';
import { withTranslation } from 'react-i18next';
import DateCell from '../../components/DateCell';
import { Link } from 'react-router-dom/cjs/react-router-dom';
import DictionariesActions from '../../redux/DictionariesRedux';
import { convertUtcToLocal } from '../../helpers/dateHelper';
import Tooltip from '@atlaskit/tooltip';
import PageWithTable from '../../components/PageWithTable';

const columns = t => ([
  {
    key: 'vin',
    dataKey: 'vin',
    title: t('VIN'),
    sortable: true,
    width: 115,
    minWidth:115,
    flexGrow: 1,
    cellRenderer: ({ cellData }) => (
      <Tooltip content={cellData}>
        <div style={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          maxWidth: 130
        }}>
          {cellData}
        </div>
      </Tooltip>
    ),
  },
  {
    key: 'iccid',
    dataKey: 'iccid',
    title: t('ICCID'),
    sortable: true,
    width: 115,
    minWidth:115,
    flexGrow: 1,
    cellRenderer: ({ cellData }) => (
      <Tooltip content={cellData}>
        <div style={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          maxWidth: 145
        }}>
          {cellData}
        </div>
      </Tooltip>
    ),
  },
  {
    key: 'reference',
    dataKey: 'reference',
    title: t('Reference'),
    sortable: true,
    width: 25,
    minWidth:25,
    flexGrow: 1,
    cellRenderer: ({ cellData }) => (
      <Tooltip content={cellData}>
        <div style={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          maxWidth: 120
        }}>
          {cellData}
        </div>
      </Tooltip>
    ),
  },
  {
    key: 'version',
    dataKey: 'version',
    title: t('Firmware'),
    sortable: true,
    width: 65,
    minWidth:65,
    flexGrow: 1,
    cellRenderer: ({ cellData }) => (
      <Tooltip content={cellData}>
        <div style={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          maxWidth: 120
        }}>
          {cellData}
        </div>
      </Tooltip>
    ),
  },
  {
    key: 'campaign',
    dataKey: 'campaign',
    title: t('Campaign'),
    sortable: true,
    width: 65,
    minWidth:65,
    flexGrow: 1,
    cellRenderer: ({ cellData }) => (
      cellData ? (
        <Tooltip content={cellData.name}>
          <div style={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}>
            <Link to={`campaigns/${cellData.id}`}>
              {cellData.name}
            </Link>
          </div>
        </Tooltip>
      ) : null
    ),
  },
  {
    key: 'bodyType',
    dataKey: 'bodyType',
    title: t('Body Type'),
    sortable: true,
    width: 10,
    minWidth:10,
    flexGrow: 1,
    cellRenderer: ({ cellData }) => (
      <Tooltip content={cellData}>
        <div style={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}>
          {cellData}
        </div>
      </Tooltip>
    ),
  },
  {
    key: 'year',
    dataKey: 'year',
    title: t('Year'),
    sortable: true,
    width: 20,
    minWidth:20,
    flexGrow: 1,
    cellRenderer: ({ cellData }) => (
      <Tooltip content={cellData}>
        <div style={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}>
          {cellData}
        </div>
      </Tooltip>
    ),
  },
  {
    key: 'make',
    dataKey: 'make',
    title: t('Make'),
    sortable: true,
    width: 50,
    minWidth:50,
    flexGrow: 1,
    cellRenderer: ({ cellData }) => (
      <Tooltip content={cellData}>
        <div style={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}>
          {cellData}
        </div>
      </Tooltip>
    ),
  },
  {
    key: 'model',
    dataKey: 'model',
    title: t('Model'),
    sortable: true,
    width: 50,
    minWidth:50,
    flexGrow: 1,
    cellRenderer: ({ cellData }) => (
      <Tooltip content={cellData}>
        <div style={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}>
          {cellData}
        </div>
      </Tooltip>
    ),
  },
  {
    key: 'firmwareLoaded',
    dataKey: 'firmwareLoaded',
    title: t('Firmware Loaded'),
    sortable: true,
    width: 50,
    minWidth:50,
    flexGrow: 1,
    cellRenderer: ({ cellData }) => (
      cellData &&
      <Tooltip content={<DateCell date={convertUtcToLocal(cellData)} />}>
        <div style={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}>
            <DateCell date={convertUtcToLocal(cellData)} />
        </div>
      </Tooltip>
    )
  },
  {
    key: 'sendFirmware',
    dataKey: 'sendFirmware',
    title: t('Firmware Sended'),
    sortable: true,
    width: 55,
    minWidth:50,
    flexGrow: 1,
    cellRenderer: ({ cellData }) => (
      cellData &&
      <Tooltip content={<DateCell date={convertUtcToLocal(cellData)} />}>
        <div style={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}>
            <DateCell date={convertUtcToLocal(cellData)} />
        </div>
      </Tooltip>
    ),
  },
  {
    key: 'error',
    dataKey: 'error',
    title: t('Firmware Error'),
    sortable: true,
    
    width: 50,
    minWidth:50,
    flexGrow: 3,
    cellRenderer: ({ cellData }) => (
      <Tooltip content={cellData}>
        
        <div style={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}>
          {cellData}
        </div>
      </Tooltip>
    ),
  },
]);

class FotaCarsPage extends Component {

  constructor(props) {
    super(props);

    this.state = {
      filterParams: {},
    }
  }

  getCarFirmwaresData = (params) => {
    const { fetchCarFirmwaresData } = this.props;

    this.setState({filterParams: params});

    return fetchCarFirmwaresData(params);
  }

  downloadXlsByFilter = () => {
    const {filterParams} = this.state;
    const {downloadXlsByFilter} = this.props;

    downloadXlsByFilter(filterParams);
  }

  render() {
    const {
      carFirmwaresData,
      fetching,
      downloadXlsByFilterFetching,
      totalPages,
      getDictionaries,
      dictionaries,
      t,
    } = this.props;
    
    return (
      <PageWithTable
        dataColumns={columns(t)}
        data={carFirmwaresData}
        dataFetching={fetching}
        dataTotalPages={totalPages}
        getData={this.getCarFirmwaresData}
        customButton={{
          title: t('Download Excel'),
          action: this.downloadXlsByFilter,
          fetching: downloadXlsByFilterFetching,
        }}
        filters={[
          {
            keyName: 'campaigns',
            placeholder: t('Campaign'),
            data: dictionaries.campaigns.data,
            fetching: dictionaries.campaigns.fetching,
            getData: getDictionaries('campaigns'),
          }
        ]}
        {...this.props}
      />
    );
  }
}

const mapStateToProps = state => ({
  carFirmwaresData: state.carFirmwares.data,
  totalPages: state.carFirmwares.totalPages,
  fetching: state.carFirmwares.fetching,
  dictionaries: state.dictionaries,
  downloadXlsByFilterFetching: state.carFirmwares.downloadXlsByFilterFetching
});

const mapDispatchToProps = dispatch => ({
  fetchCarFirmwaresData: params => dispatch(FotaCarsActions.carFirmwaresRequest(params)),
  downloadXlsByFilter: params => dispatch(FotaCarsActions.downloadXlsByFilterRequest(params)),
  getDictionaries: name => () => dispatch(DictionariesActions.dictionariesRequest(name)),
});

export default withTranslation('fota')(connect(
  mapStateToProps,
  mapDispatchToProps,
)(FotaCarsPage));
